﻿import { computed, getCurrentInstance, toRef, WritableComputedRef } from 'vue'
export function useVModel<
    P extends object,
    K extends keyof P,
    Name extends string
>(
    props: P,
    key: K,
    emit: (e: Name, ...args: any[]) => void,
    defaultValue: Exclude<P[K], null | undefined>
): WritableComputedRef<Exclude<P[K], null | undefined>>
export function useVModel<
    P extends object,
    K extends keyof P,
    Name extends string
>(
    props: P,
    key: K,
    emit: (e: Name, ...args: any[]) => void,
    defaultValue?: P[K] | Exclude<P[K], null | undefined>
): WritableComputedRef<P[K] | Exclude<P[K], null | undefined>> {
    function isDefaultValueDefined(
        x: any
    ): x is Exclude<P[K], null | undefined> {
        return x !== undefined && x !== null
    }
    const vm = getCurrentInstance()
    const _emit = emit || vm?.emit || vm?.proxy?.$emit?.bind(vm?.proxy)

    key = key ? key : ('modelValue' as K)

    const event = `update:${key.toString()}` as Name
    const _value = toRef(props, key)
    if (isDefaultValueDefined(defaultValue)) {
        return computed<Exclude<P[K], null | undefined>>({
            get() {
                return _value.value ?? defaultValue
            },
            set(value) {
                _emit(event, value)
            }
        })
    }
    return computed<P[K]>({
        get() {
            return _value.value
        },
        set(value) {
            _emit(event, value)
        }
    })
}
